<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Add Material Specification</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
        <v-row justify="center" dense>
            <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material</b></p>
                <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="inventory_material"
                :items="inventory_material_list"
                item-text="name"
                item-value="id"
                label="Material"
                outlined
                />
        </v-col>
        </v-row>
        <v-row justify="center" dense v-if="inventory_material">
         <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Specification</b></p>
           <v-textarea
            label="Specification"
            v-model="specification"
            value
            placeholder="Enter Specification"
            hint="Enter Specification"
            outlined
          ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="inventory_material && specification">
          <v-btn color="warning" @click="saveInventoryMaterialSpecification()" :loading="loader"
            >Add</v-btn
          >
        </v-row>
       </v-card>

     <v-card class="box" v-if="inventory_material_specification_list!='' ">
     <v-data-table  :headers="headers" :items="inventory_material_specification_list" :items-per-page="-1">
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Inventory Material Specification List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
         <template v-slot:[`item.isactive`]="{ item }">
                 <v-switch v-model="item.isactive"  @change="toggleIsactiveInventoryMaterialSpecification(item)"
                 :color="item.isactive ? 'success' : 'primary'"></v-switch>
      </template>
       <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="deleteInventoryMaterialSpecification(item)"
                >mdi-trash-can</v-icon
              >
            </v-avatar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="editDetail(item)"
                >mdi-pencil</v-icon
              >
            </v-avatar>
          </template>
           <template v-slot:[`item.islast`]="{ item }">
            <span v-if="item.islast">
              <v-icon class="mr-2 v-icon-size" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error"
                >mdi-close-circle-outline</v-icon
              >
            </span>
          </template>
     </v-data-table>
 </v-card>

         <v-dialog
        v-model="dialog_edit"
        persistent
        scrollable="false"
        max-width="1200px"
        transition="dialog-bottom-transition"
      >
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Material Specification</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <br>
            <v-row justify="center" dense>
            <v-col cols="12" sm="3">
            <p><b>Material</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="editedItem.inventory_material"
              :items="inventory_material_list"
              item-text="name"
              item-value="id"
              label="Material"
              outlined
              disabled
            />
                </v-col>
            </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Specification</b></p>
             <v-textarea
            label="Specification"
            v-model="editedItem.specification"
            value
            placeholder="Enter Specification"
            hint="Enter Specification"
            outlined
          ></v-textarea>
        </v-col>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveUpdateInventoryMaterialSpecification()"
              >Update</v-btn
            >
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      inventory_material_list:[],inventory_material:"",
      inventory_material_specification_list:[],specification:"",
      headers:[
      { text: "SR No", value: "srno" },
      { text: "Material", value: "invmaterial" },
      { text: "Specification", value: "specification" },
      { text: "Is Active", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
      ],
    dialog_edit: false,
    editedItem: {
      id: "",specification:"",inventory_material:""
    },
  }),
   methods: {
      clearData(){
        this.inv_finance_approving_authority="",this.inv_finance_approving_category="",this.level_no="",this.islast=false
      },
      async saveUpdateInventoryMaterialSpecification(){
       this.overlay = true;
       this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveUpdateInventoryMaterialSpecification", this.editedItem);
          if (res.data.flag == "YES") {
            this.inventory_material_specification_list=res.data.inventory_material_specification_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar  
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
         this.dialog_edit = false;
      }
    },
    editDetail(item) {
      this.editedItem.id = item.id;
      this.editedItem.specification = item.specification;
      this.editedItem.inventory_material = item.invmaterial_id;
      this.dialog_edit = true;
    },
    async saveInventoryMaterialSpecification(){
        const data = {
        inventory_material:this.inventory_material,
        specification:this.specification,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveInventoryMaterialSpecification", data);
          if (res.data.flag == "YES") {
            this.inventory_material_specification_list=res.data.inventory_material_specification_list
            this.showSnackbar("green", "Saved Successfully"); // show snackbar   
            this.clearData();
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async toggleIsactiveInventoryMaterialSpecification(item){
        const data = {
            id: item.id,
            isactive: item.isactive,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/toggleIsactiveInventoryMaterialSpecification", data);
          if (res.data.flag == "YES") {
             this.inventory_material_specification_list=res.data.inventory_material_specification_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar    
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async deleteInventoryMaterialSpecification(item){
       if (!confirm("Are You Sure You Want To Delete This Item?"))
        return;
        const data = {
            id: item.id,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/deleteInventoryMaterialSpecification", data);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Deleted Successfully"); // show snackbar    
             this.inventory_material_specification_list=res.data.inventory_material_specification_list
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
    async onLoad() {
      try {
          const res = await axios.post("/Inventory/getInventoryMaterialSpecificationList");
          if (res.data.flag == "YES") {
            this.inventory_material_list=res.data.inventory_material_list
            this.inventory_material_specification_list=res.data.inventory_material_specification_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>